import { createAction } from '@mews/framework';
import { RATE_ID_SELECTED, DEFAULT_RATES_CLEARED, MOBILE_RATE_GROUP_ID_SELECTED } from './types';

export const selectRateId = (rateGroupId: string, rateId: string, scope: string) =>
    createAction(RATE_ID_SELECTED, { rateGroupId, rateId }, { scope });

export const selectMobileRateGroupId = (rateGroupId: string, scope: string) =>
    createAction(MOBILE_RATE_GROUP_ID_SELECTED, rateGroupId, { scope });

export const clearDefaultRates = (scope: string) => createAction(DEFAULT_RATES_CLEARED, undefined, { scope });
